import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCLSavedPrescription } from '../../../../actionCreators/product';
import RightIcon from '../../../../../static/assets/svg/icon-right.svg';
import LeftIcon from '../../../../../static/assets/svg/icon-left.svg';
import './NewCLPrescription.scss';
import { formatDate } from '../../../../utils/helper';

const NewCLPrescription = props => {
  const {
    selectedSavedPrescription,
    selectSavedPrescription,
    dataLocale,
    isJitProduct,
    contactPrescription,
    showSubError,
    updateShowSubError,
  } = props;
  const savedPrescription = useSelector(state => state.product.savedPrescription);
  const isLoaded = useSelector(state => state.product.isCLSavedPresLoaded);
  const inValidPres = useSelector(state => state.product.inValidPres);
  const isContactPrescription = useSelector(state => state.product.isContactPrescValid);
  const isNonJitPowerValidated = useSelector(state => state.product.isNonJitPowerValid);
  const dispatch = useDispatch();
  const [currentSavedPrescription, setCurrentSavedPrescription] = useState(
    savedPrescription?.result[0]
  );
  const [currentSavedPrescriptionIndex, setCurrentSavedPrescriptionIndex] = useState(0);

  const {
    LEFT_EYE,
    RIGHT_EYE,
    NO_POWER_SAVED_CURRENTLY,
    SELECT_FROM_AVAILBALE_OPTIONS,
    ADDED_ON,
    SELECTED,
    SELECT,
    SPHERICAL_POWER,
    CYLINDRICAL_POWER,
    AXIS_POWER,
    PD_POWER,
  } = dataLocale;

  useEffect(() => {
    if (!savedPrescription) dispatch(getCLSavedPrescription());
  }, []);

  useEffect(() => {
    if (savedPrescription && savedPrescription?.result?.length > 0) {
      setCurrentSavedPrescription(savedPrescription?.result[0]);
      setCurrentSavedPrescriptionIndex(0);
      selectSavedPrescription(savedPrescription?.result[0]);
    }
  }, [savedPrescription]);

  return (
    <div className="saved-prescription-container">
      {!isLoaded && (
        <div className="text-center cl-spinner">
          <i className="fa fa-spinner fa-spin fa-5x fa-fw"></i>
        </div>
      )}
      {isLoaded && savedPrescription && savedPrescription?.result?.length === 0 && (
        <div className="no-prescription-text">
          <p>{NO_POWER_SAVED_CURRENTLY}</p>
          <p>{SELECT_FROM_AVAILBALE_OPTIONS}</p>
        </div>
      )}
      {isLoaded && currentSavedPrescription && (
        <div key={currentSavedPrescription?.id} className="saved-pres-wrapper">
          {currentSavedPrescription?.id !== savedPrescription?.result[0]?.id && (
            <div
              className="navigation-arrow arrow-right"
              onClick={() => {
                setCurrentSavedPrescription(
                  savedPrescription?.result[currentSavedPrescriptionIndex - 1]
                );
                setCurrentSavedPrescriptionIndex(currentSavedPrescriptionIndex - 1);
                updateShowSubError(false);
              }}
            >
              <img alt="next saved prescription" src={RightIcon} />
            </div>
          )}
          {currentSavedPrescription?.id !==
            savedPrescription?.result[savedPrescription?.result?.length - 1]?.id && (
            <div
              className="navigation-arrow arrow-left"
              onClick={() => {
                setCurrentSavedPrescription(
                  savedPrescription?.result[currentSavedPrescriptionIndex + 1]
                );
                setCurrentSavedPrescriptionIndex(currentSavedPrescriptionIndex + 1);
                updateShowSubError(false);
              }}
            >
              <img alt="previous saved prescription" src={LeftIcon} />
            </div>
          )}
          <div className="saved-pres-header">
            <div className="user-details">
              <div className="user-details-initial">{currentSavedPrescription?.userName[0]}</div>
              <div className="user-details-text">
                <p className="user-name">{currentSavedPrescription?.userName}</p>
                <p className="saved-pres-date">
                  {ADDED_ON}: {formatDate(currentSavedPrescription?.recordedAt, 'D MMM', 'year')}
                </p>
              </div>
            </div>
            {selectedSavedPrescription?.id === currentSavedPrescription?.id ? (
              <button className="selected-status">
                <img
                  alt="prescription selected"
                  src="https://static1.lenskart.com/media/desktop/img/DesignStudioIcons/CheckFilledBlue.svg"
                />{' '}
                {SELECTED}
              </button>
            ) : (
              <button
                className="selected-status"
                onClick={() => selectSavedPrescription(currentSavedPrescription)}
              >
                {SELECT}
              </button>
            )}
          </div>
          <div className="saved-pres-body">
            <div className="saved-pres-power-type">
              {currentSavedPrescription?.powerType &&
                currentSavedPrescription.powerType.replace(/_/g, ' ')}
            </div>
            <ul className="power-type-list">
              <li className="power-type-list-item">
                <p className="power-type-title"></p>
                <div className="power-type-numbers">
                  <p className="power-type-number-right">{RIGHT_EYE}</p>
                  <p className="power-type-number-left">{LEFT_EYE}</p>
                </div>
              </li>
              <li className="power-type-list-item">
                <p className="power-type-title">{SPHERICAL_POWER}</p>
                <div className="power-type-numbers">
                  <p className="power-type-number-right">
                    {currentSavedPrescription.right.sph ? currentSavedPrescription.right.sph : '-'}
                  </p>
                  <p className="power-type-number-left">
                    {currentSavedPrescription.left.sph ? currentSavedPrescription.left.sph : '-'}
                  </p>
                </div>
              </li>
              <li className="power-type-list-item">
                <p className="power-type-title">{CYLINDRICAL_POWER}</p>
                <div className="power-type-numbers">
                  <p className="power-type-number-right">
                    {currentSavedPrescription.right.cyl ? currentSavedPrescription.right.cyl : '-'}
                  </p>
                  <p className="power-type-number-left">
                    {currentSavedPrescription.left.cyl ? currentSavedPrescription.left.cyl : '-'}
                  </p>
                </div>
              </li>
              <li className="power-type-list-item">
                <p className="power-type-title">{AXIS_POWER}</p>
                <div className="power-type-numbers">
                  <p className="power-type-number-right">
                    {currentSavedPrescription.right.axis
                      ? currentSavedPrescription.right.axis
                      : '-'}
                  </p>
                  <p className="power-type-number-left">
                    {currentSavedPrescription.left.axis ? currentSavedPrescription.left.axis : '-'}
                  </p>
                </div>
              </li>
              {currentSavedPrescription.showPd && (
                <li className="power-type-list-item">
                  <p className="power-type-title">{PD_POWER}</p>
                  <div className="power-type-numbers">
                    <p className="power-type-number-right">
                      {currentSavedPrescription.right.pd ? currentSavedPrescription.right.pd : '-'}
                    </p>
                    <p className="power-type-number-left">
                      {currentSavedPrescription.left.pd ? currentSavedPrescription.left.pd : '-'}
                    </p>
                  </div>
                </li>
              )}
            </ul>
          </div>
          <div className="saved-pres-errors">
            {contactPrescription === false && inValidPres && showSubError && (
              <div className="alert alert-danger user-saved-isvalid margin-b5 padding-5">{`${
                isContactPrescription.code
                  ? `${isContactPrescription.error}`
                  : `${isContactPrescription.message}`
              }`}</div>
            )}
            {!isNonJitPowerValidated && !isJitProduct && isContactPrescription && showSubError && (
              <ul
                className="alert alert-danger user-saved-isvalid"
                style={{
                  padding: '5px',
                  paddingLeft: '10px',
                  width: '99.5%',
                  marginLeft: '.25%',
                  marginBottom: '5px',
                }}
              >
                {isContactPrescription?.result[0]?.leftQuantityValidationError && showSubError && (
                  <li className="bullet-list">{`${LEFT_EYE}: ${isContactPrescription.result[0].leftQuantityValidationError}`}</li>
                )}
                {isContactPrescription?.result[0]?.rightQuantityValidationError && showSubError && (
                  <li className="bullet-list">{`${RIGHT_EYE}: ${isContactPrescription.result[0].rightQuantityValidationError}`}</li>
                )}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NewCLPrescription;
